import { observer } from 'mobx-react'
import React from 'react'
import BZRXCommonCompensation from './BZRXCommonCompensation'
import CompensationVM from './CompensationVM'
import { Icon } from 'ui-framework'

export function BZRXCompensation({ vm }: { vm: CompensationVM }) {
  const { BZRX_COMPENSATION1, BZRX_COMPENSATION2 } = vm.airdropStore.airdropsInfo
  const tokenName = vm.isBadBoy && BZRX_COMPENSATION1.amount.gt(0) ? 'vBZRX' : 'BZRX'

  return (
    <div className="grid-fluid-colmin-22em">
      <div className="panel--simple md-padded-2">
        <h3 className="panel__header title-section">How does it work?</h3>
        <div className="txt-read-optimized txt-explanation">
          <p className="txt-warning">
            <b>You will receive the BZRX compensation on Polygon</b>, <br /> regardless of whether
            your tokens were lost on BSC or Polygon.
          </p>
          <ol className="list-spaced-1">
            <li>Insert your address to know your compensation.</li>
            <li>There will be also a security check of your wallet.</li>
            <li>Finally, you will be able to claim your compensation on Polygon.</li>
          </ol>
        </div>
      </div>

      <div className="panel--simple md-padded-2">
        <h3 className="panel__header title-section flex-row-center">
          <Icon name="token-bzrx" size={24} />
          <span className="margin-left-1ch">{tokenName} Compensation</span>
        </h3>

        <BZRXCommonCompensation
          vm={vm}
          compensations={[BZRX_COMPENSATION1, BZRX_COMPENSATION2]}
          chainIdNeeded={137}
        />
      </div>
    </div>
  )
}

export default observer(BZRXCompensation)
